module.exports = __webpack_public_path__ + "img/gradient-left.8fe083d8.png";